import http from '@/utils/request'
export default {
    initProjectWritingSopWiki: {
        url: '/api/project-writing/sop/node/init-tenant',
        name: '初始化SOP Wiki',
        post: async function(data) {
            return await http.post(this.url, data, { baseURL: '' })
        }
    },
    selfRegistrationList: {
        url: 'tenant/selfRegister/query',
        name: '自主注册列表',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    newTenant: {
        url: 'tenant/newTenant',
        name: '新建租户',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    getUserList: {
      url: 'tenant/user/query',
      name: '查询用户',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    tenantManagementList: {
        url: 'tenant/management',
        name: '租户管理列表',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    customerAuthManagementPage: {
        url: 'tenant/customerAuth/page',
        name: '客户授权管理列表',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    officialAccountLeadPage: {
        url: 'officialAccountLead/page',
        name: '服务号授权客户列表',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    batchUpdateServiceEngineer: {
        url: 'tenant/batchUpdate/serviceEngineer',
        name: '批量更新服务工程师',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    batchUpdateBusinessManager: {
        url: 'tenant/batchUpdate/businessManager',
        name: '批量更新商务经理',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    getTenantDetail: {
        url: '/tenant/detail',
        name: '租户详情-基本信息-查询',
        get: async function(params) {
            return await http.get(this.url + '/' + params.id)
        }
    },
    saveDetail: {
        url: 'tenant/saveDetail',
        name: '新建租户',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    tenantRenewal: {
        url: 'tenant/renewal',
        name: '租户续约',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    getRenewal: {
        url: 'tenant/getRenewal',
        name: '查询租户的续约记录',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    oneClickLogin: {
        url: 'oms/oneClickLogin',
        name: '一键登录',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    getCustomerList: {
      url: 'tenant/findCustomers',
      name: '查询指定租户下的客户数据',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getRecord: {
        url: '/record/getRecord',
        name: '查询跟进',
        get: async function(params, headers = {}) {
            return await http.get(this.url, params, { headers });
        }
    },
    publishRecord: {
        url: '/record/publish',
        name: '发布跟进',
        post: async function(data, headers = {}) {
            return await http.post(this.url, data, { headers });
        }
    },
    fileUpload: {
      url: 'file/upload',
      name: '上传文件',
      post: async function(data, config={headers:{'Content-Type': 'multipart/form-data;charset=UTF-8'}}) {
        var param = new FormData()
        Object.keys(data).forEach(key => {
            param.append(key, data[key])
        })
        return await http.post(this.url, param, config)
      }
    },
    deleteRecord: {
        url: '/record/delete',
        name: '删除跟进',
        get: async function(params, headers = {}) {
            return await http.get(this.url, params, { headers });
        }
    },
    getTenantErrorLog: {
        url: '/tenant/errorLog',
        name: '查询租户的报错日志',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    getTenantOperationLog: {
        url: '/tenant/operationLog',
        name: '查询租户的操作日志',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    tenantStatisticsList: {
        url: '/tenant/statistics',
        name: '租户统计',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    tenantStatisticsAnalysis: {
        url: '/tenant/statistics/analysis',
        name: '租户统计分析',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    exportTenantStatisticsAnalysis: {
        url: '/tenant/export/analysis',
        name: '导出租户统计分析',
        post: async function(data) {
            return await http.post(this.url, data, { responseType: 'blob' })
        }
    },
    getDataInfo: {
        url: '/tenant/getDataInfo',
        name: '查询数据信息',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    customerIncrement: {
        url: 'tenant/dashboard/customer',
        name: '仪表盘-客户新增数量',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    caseIncrement: {
        url: 'tenant/dashboard/case',
        name: '仪表盘-案件新增',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    caseSubmitCount: {
        url: 'tenant/dashboard/caseSubmit',
        name: '案件递交数',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    officialSubmitCount: {
        url: 'tenant/dashboard/official',
        name: '官文递交数',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    dashboardOtherCount: {
        url: 'tenant/dashboard/other',
        name: '仪表盘其他数据',
        get: async function(data) {
            return await http.get(this.url, data)
        }
    },
    moduleTrialList: {
        url: 'tenant/trial/query',
        name: '试用模块查询',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    batchUpdateTrialModule: {
        url: 'tenant/trial/update',
        name: '试用模块处理',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    batchUpdateTrialStatus: {
        url: 'tenant/trial/updateStatus',
        name: '试用模块 批量修改试用状态',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    // 版本更新相关接口
    versionUpdateList: {
        url: 'version/pageList',
        name: '版本更新列表',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    // 查询租户
    findTenantList: {
        url: 'tenant/findTenant',
        name: '查询租户',
        get: async function(data) {
            return await http.get(this.url, data);
        }
    },
    saveVersion: {
        url: 'version/save',
        name: '保存版本信息',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    versionRelease: {
        url: 'version/versionRelease',
        name: '版本发布',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    deleteVersion: {
        url: 'version/delete',
        name: '删除版本',
        get: async function(data) {
            return await http.get(this.url, data);
        }
    },
    batchUpdateTrialRemark: {
        url: 'tenant/trial/updateRemark',
        name: '试用模块批量修改备注',
        post: async function(data) {
            return await http.post(this.url, data);
        }
    },
    selfNewTenant: {
        url: 'tenant/self/newTenant',
        name: '自主注册-开通',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    updateTenantStatus: {
        url: 'tenant/updateTenantStatus',
        name: '启用或停用租户',
        get: async function(params) {
            return await http.get(this.url, params)
        }
    },
    deleteYarlyFeeMonitor: {
        url: 'tenant/yearlyFeeMonitor/delete',
        name: '删除租户下未监控的数据',
        post: async function(params) {
            return await http.post(this.url, params)
        }
    },
    operationManagementList: {
        url: 'management/query',
        name: '操作管理列表',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    exportAll: {
        url: 'tenant/export/all',
        name: '租户统计-全部导出',
        post: async function(data, config={responseType: 'blob'}) {
            return await http.post(this.url, data, config)
        }
    },
    exportSelected: {
        url: 'tenant/export',
        name: '租户统计-选择导出',
        post: async function(data, config={responseType: 'blob'}) {
            return await http.post(this.url, data, config)
        }
    },
    updateOfficialStatus: {
        url: 'management/official/update',
        name: '修改官文状态',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    deleteOfficial: {
        url: 'management/official/delete',
        name: '删除官文',
        get: async function(params) {
            return await http.get(this.url, params)
        }
    },
    batchDeleteOfficial: {
        url: 'management/official/batch/delete',
        name: '批量删除官文',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    findAdminFile: {
        url: 'version/findAdminFile',
        name: '根据批次ID查询文件列表',
        get: async function(params) {
            return await http.get(this.url, params)
        }
    },
    dateManagementQueryYear: {
        url: 'dateManagement/queryYear',
        name: '日期管理-查询年份数据',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    dateManagementSyncThreeYears: {
        url: 'dateManagement/syncThreeYears',
        name: '日期管理-同步三年官方数据',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
    dateManagementSaveOverride: {
        url: 'dateManagement/override/save',
        name: '日期管理-保存自定义覆盖',
        post: async function(data) {
            return await http.post(this.url, data)
        }
    },
}
